module.exports = __webpack_public_path__ + "img/me.6983a13a.jpg";